module.exports = require("./ff-Latn-NG");